import type { IntlShape } from 'react-intl';

export enum BudgetCounterProposalSubStatusEnum {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export const BudgetCounterProposalSubStatusLabelMap: Record<
  BudgetCounterProposalSubStatusEnum,
  string
> = {
  [BudgetCounterProposalSubStatusEnum.ACCEPTED]: 'Aceito',
  [BudgetCounterProposalSubStatusEnum.REJECTED]: 'Recusado',
};

export const getBudgetCounterProposalSubStatusLabel = (
  subStatus: BudgetCounterProposalSubStatusEnum | string,
): string => {
  if (subStatus in BudgetCounterProposalSubStatusLabelMap) {
    return BudgetCounterProposalSubStatusLabelMap[subStatus as BudgetCounterProposalSubStatusEnum];
  }
  return subStatus;
};

export const BudgetCounterProposalSubStatusLabelIdMap: Record<
  BudgetCounterProposalSubStatusEnum,
  string
> = {
  [BudgetCounterProposalSubStatusEnum.ACCEPTED]: 'intl-msg:budgets.shared.counterProposalSubStatus.accepted',
  [BudgetCounterProposalSubStatusEnum.REJECTED]: 'intl-msg:budgets.shared.counterProposalSubStatus.rejected',
};

export const getBudgetCounterProposalSubStatusLabelId = (
  subStatus: BudgetCounterProposalSubStatusEnum | string,
): string | undefined => {
  if (subStatus in BudgetCounterProposalSubStatusLabelIdMap) {
    return BudgetCounterProposalSubStatusLabelIdMap[subStatus as BudgetCounterProposalSubStatusEnum];
  }
  return undefined;
};

export const translateBudgetCounterProposalSubStatus = (
  intl: IntlShape,
  subStatus: BudgetCounterProposalSubStatusEnum | string,
): string => {
  const id = getBudgetCounterProposalSubStatusLabelId(subStatus);
  return id ? intl.formatMessage({ id }) : subStatus;
};
